import { Card } from "../../../components/cards";
import { useMe } from "../../users/hooks/useMe";
import { Activity, Building2, Package, ShoppingCart } from "lucide-react";
import { UsersInfos } from "../../users/components";
import { TasksWidget } from "../../tasks/components";
import { useCustomers } from "../../customers/hooks";
import { useProducts } from "../../products/hooks";
import { useOrders } from "../../orders/hooks";
import {
  StockAlertWidget,
  RecentCustomersWidget,
  RecentOrdersWidget,
  OrdersToDeliverWidget,
  QuickPickupScanWidget,
  GivenCansShortcut,
} from "../components";

export const Admin = () => {
  const { data } = useMe();
  const { data: customersData } = useCustomers({ where: {} });
  const { data: productsData } = useProducts({
    where: {},
    limit: 1,
    offset: 0,
  });
  const { data: ordersData } = useOrders({ where: {} });

  return (
    <div className="space-y-4 p-2">
      {/* Welcome Banner */}
      <Card
        padding="md"
        className="bg-gradient-to-r from-primary-600 to-primary-700 border-0 text-white"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
            <Activity className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-bold mb-1">
              Bienvenue, {data?.me?.firstname || "Admin"}
            </h2>
            <p className="text-sm text-white/90">
              Vue d'ensemble de votre activité commerciale
            </p>
          </div>
        </div>
      </Card>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card hover padding="sm" className="shadow-sm border border-gray-200">
          <div className="flex items-center justify-between gap-2">
            <div className="flex-1 min-w-0">
              <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
                Clients
              </p>
              <p className="text-sm sm:text-lg font-bold text-gray-900 truncate">
                {customersData?.customers?.total ?? 0}
              </p>
              <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
                Clients enregistrés
              </p>
            </div>
            <div className="bg-blue-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
              <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
            </div>
          </div>
        </Card>

        <Card hover padding="sm" className="shadow-sm border border-gray-200">
          <div className="flex items-center justify-between gap-2">
            <div className="flex-1 min-w-0">
              <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
                Produits
              </p>
              <p className="text-sm sm:text-lg font-bold text-gray-900 truncate">
                {productsData?.products?.total ?? 0}
              </p>
              <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
                Produits au catalogue
              </p>
            </div>
            <div className="bg-green-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
              <Package className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" />
            </div>
          </div>
        </Card>

        <Card hover padding="sm" className="shadow-sm border border-gray-200">
          <div className="flex items-center justify-between gap-2">
            <div className="flex-1 min-w-0">
              <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
                Commandes
              </p>
              <p className="text-sm sm:text-lg font-bold text-gray-900 truncate">
                {ordersData?.orders?.total ?? 0}
              </p>
              <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
                Commandes au total
              </p>
            </div>
            <div className="bg-orange-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
              <ShoppingCart className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" />
            </div>
          </div>
        </Card>

        <UsersInfos />
      </div>

      {/* Scan rapide */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <QuickPickupScanWidget />
        <GivenCansShortcut />
      </div>

      {/* Stock & Livraisons */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <StockAlertWidget />
        <OrdersToDeliverWidget />
      </div>

      {/* Clients & Commandes récentes */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <RecentCustomersWidget />
        <RecentOrdersWidget />
      </div>

      {/* Tâches */}
      <div className="grid grid-cols-1 gap-4">
        {data?.me?.id && <TasksWidget userId={data.me.id} />}
      </div>
    </div>
  );
};
